import * as React from "react";

import "./analytics-states.scss";
import { xdQAAttribute }        from "../../analytics-layout";
import { analyticSummaryArray } from "../analytics-locale";
import { AnalyticsMap }         from "./analytics-map";
import { states }               from "./states-svg";

const KEY_ANALYTIC = 'state'
const INDEX_OUT_OF_BOUNDS = -1
const DISPLAY_MAX = 5

export const AnalyticsStates = ({leadInteractions, zipCodes, hasMultipleStateLeads, filters, setFilters}) => {
    const viewBox = `0 0 1000 589`
    const [hoveredValue, setHoveredValue] = React.useState(null)
    const [selectedState, setSelectedState] = React.useState(false)
    const values = analyticSummaryArray(leadInteractions, KEY_ANALYTIC, 'idLead', KEY_ANALYTIC)
    const stroke="#FFFFFF"
    const fill = "#33415040"
    const showSingleStateMap = [...new Set(leadInteractions.map(item => item.state))].length === 1;

    React.useEffect(() => {
        if (filters.length === 0) {
            setSelectedState(false);
        }
    }, [filters]);

    return (
        (!hasMultipleStateLeads || selectedState || showSingleStateMap) ? <div className="state-map-us123">
            <div className="states-container">
                {hasMultipleStateLeads && <svg
                    className="mini-state-map"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox={viewBox}
                    {...xdQAAttribute('image', 'state chart')}
                    onClick={() => {
                        setFilters([])
                        setSelectedState(!selectedState)
                    }}
                >
                    {
                        states?.map(state => {
                            const stateIndex = analyticIndex(values, state.id)
                            let ratio = 1;
                            const stateCount = values.find(value => value.label === state.id)?.count || 0;
                            if (stateIndex !== INDEX_OUT_OF_BOUNDS && stateCount) {
                                ratio = stateCount / values[0].count;
                            }
                            const fillColor = stateIndex === INDEX_OUT_OF_BOUNDS
                                ? "rgba(200, 200, 200, 1)"
                                : getInterpolatedColor(ratio);

                            return (
                                <path
                                    className="path-state"
                                    key={state.id}
                                    stroke={stroke}
                                    fill={fillColor}
                                    strokeWidth="1"
                                    d={state.path}
                                    onPointerEnter={() => setHoveredValue(state.id)}
                                    onPointerLeave={() => setHoveredValue(null)}
                                    {...xdQAAttribute('image', 'state path')}
                                />
                            )
                        })
                    }
                </svg>}
                {zipCodes && zipCodes.length > 0 && (<AnalyticsMap {...{leadInteractions, zipCodes}}/>)}
            </div>
        </div>
        : <div className="state-map-us123" >
            <div className="state-header">
                <h5
                    className="title"
                    {...xdQAAttribute('label', 'state title')}
                >
                    States
                </h5>
                <p
                    className="subtitle"
                    {...xdQAAttribute('text', 'state subtitle')}
                >
                    {subheaderText(values)}
                </p>
            </div>
            <div className="state-data">
                <div className="state-legend">
                    {
                        values.map((value, i) => {
                            const stateId = value.label
                            const stateName = stateNameFromId(stateId)
                            const stateCount = value.count
                            const ratio = values[i].count / values[0].count
                            return (
                                <div
                                    key={i}
                                    className={`state-list-item-container
                                        ${stateId === hoveredValue ? ' hovered' : ''}`}
                                    onClick={() => {
                                        setFilters(prev => [
                                            ...prev.filter(f => f.filterKey !== "state"),
                                            { filterKey: "state", values: [stateId] }
                                        ]);
                                        setSelectedState(!selectedState)
                                    }}
                                    onPointerEnter={() => setHoveredValue(stateId)}
                                    onPointerLeave={() => setHoveredValue(null)}
                                >
                                    <li
                                        className="state-list-item"
                                        style={{color: getInterpolatedColor(ratio)}}
                                    >
                                        <span className="state-text">
                                            <p
                                                className="state-name"
                                                {...xdQAAttribute('text', stateName)}
                                            >
                                                {stateName}
                                            </p>
                                            <p
                                                className="state-count"
                                                {...xdQAAttribute('text', `count ${stateName}`)}
                                            >
                                                {stateCount}
                                            </p>
                                        </span>
                                    </li>
                                </div>
                            )
                        })

                    }
                </div>
                <svg
                    className="state-map"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox={viewBox}
                    {...xdQAAttribute('image', 'state chart')}
                >
                    {
                        states?.map((state, i) => {
                            const stateIndex = analyticIndex(values, state.id)
                            const isHovered = hoveredValue === state.id;
                            const hasLeadsInState = leadInteractions.some(
                                (lead) => lead.state === state.id
                            );
                            let ratio = 1;
                            const stateCount = values.find(value => value.label === state.id)?.count || 0;
                            if (stateIndex !== INDEX_OUT_OF_BOUNDS && stateCount) {
                                ratio = stateCount / values[0].count;
                            }
                            const fillColor = stateIndex === INDEX_OUT_OF_BOUNDS
                                ? "rgba(200, 200, 200, 1)"
                                : getInterpolatedColor(ratio);

                            return (
                                <path
                                    className={`path-state ${hasLeadsInState ? "hoverable" : "not-hoverable"}`}
                                    key={state.id}
                                    stroke={stroke}
                                    fill={fillColor}
                                    strokeWidth="1"
                                    d={state.path}
                                    onPointerEnter={() => {
                                        if (hasLeadsInState) setHoveredValue(state.id);
                                    }}
                                    onPointerLeave={() => setHoveredValue(null)}
                                    onClick={() => {
                                        if(hasLeadsInState) {
                                            setFilters(prev => [
                                                ...prev.filter(f => f.filterKey !== "state"),
                                                { filterKey: "state", values: [state.id] }
                                            ]);
                                            setSelectedState(!selectedState)
                                        }
                                    }}
                                    style={{
                                        cursor: hasLeadsInState ? 'pointer' : 'default'
                                    }}
                                    {...xdQAAttribute('image', 'state path')}
                                />
                            )
                        })
                    }
                </svg>
            </div>
        </div>
    )
}

const subheaderText = (values) => {
    if(!values) {
        return 'No leads found'
    }
    if(values.length === 0) {
        return 'No leads found'
    }
    if(values.length === 1) {
        return 'State with the most leads'
    }

    return 'States with the most leads'
}

const analyticIndex = (array, analytic) => {
    for(let i = 0; i < array.length; i++) {
        if(array[i].label === analytic) {
            return i
        }
    }

    return INDEX_OUT_OF_BOUNDS
}

const stateNameFromId = (id) => {
    const state = states.find(state => state.id === id)
    return state?.name || ''
}

function getInterpolatedColor(ratio, from = '#BCDFFB', to = '#0A4AA1') {
    // Convert hex to RGB
    const hexToRgb = hex => {
        const bigint = parseInt(hex.replace('#', ''), 16);
        return {
            r: (bigint >> 16) & 255,
            g: (bigint >> 8) & 255,
            b: bigint & 255
        };
    };

    const interpolate = (start, end, t) => Math.round(start + (end - start) * t);

    const start = hexToRgb(from);
    const end = hexToRgb(to);

    const r = interpolate(start.r, end.r, ratio);
    const g = interpolate(start.g, end.g, ratio);
    const b = interpolate(start.b, end.b, ratio);

    return `rgb(${r}, ${g}, ${b})`;
}
